<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">

                <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                                style="background: url('/assets/images/PexelsForkInRoadAroundBuilding1.jpg')  center;">
                        <h3 class="widget-user-desc text-left">Stop Self-Sabotage.</h3>

                                    <h3 class="widget-user-username text-right">Conquer the Grip of the Past.</h3>
<h2 class="widget-user-desc text-left">Overcome your Demons.</h2>
                    </div>
                    <div class="widget-user-image">
                        <img class="img-circle" src="/assets/images/beginner_child.png" alt="User Avatar">
                    </div>
                </div>
                    <!-- <div class=" card card-primary col-sm-12 col-xl-6 mx-auto">
                        <div class="card-header">
                            <h4 class="card-title text-center">How to Analyse your Self-Sabotage</h4>
                            <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove">
                                <i class="fas fa-times"></i>
                            </button>
                            </div>
                        </div>
                        <div class="card-body" >
                            <div style="text-align:left;" v-html="headerHTML">
                            </div>
                        </div>
                    </div> -->

                            <div class="content-box-gray card mb-2">
                                <div :hidden="hideHeaderInputs" class="title text-center">
                                    <h5 class="mt-2" style="margin:auto;" >Manage Self-Sabotage Behaviours:</h5>
                                </div>


                                <div :hidden="!hideHeaderInputs" class="content-box-gray card" >
                                    <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >Manage Self-Sabotage Behaviours:</h5>
                                    </div>
                                    <div class="goal-head" >
                                        <b>My Goal:</b> {{kss_name}} <b>&amp; My Why: </b> {{ kss_desc }}
                                    </div>
 <div class="periods-head"> Me: Stuck with my Past-Self</div>
                                    <div class="row justify-content-between" >

                                        <div class="col-4">
                                             <h3  class="component-head txt-primary bg-secondary">Goal-Defeating<br/> Actions/Inactions </h3>
                                            <div>
                                                <ul>
                                                    <li v-for="(action, index) in past_actions" :key="index" >
                                                        {{action}}&nbsp; <i  @click="deleteFormerComp(action, 'action')" class="fas fa-trash fai-red fai-sm" title="Delete"></i>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="input-group" style="font-size:.85em;">
                                                <input id="id_new_action"  type="text" class="form-control" v-model="kss_action_desc" placeholder="Heavy snacking and Binging" required>
                                                <div  class="input-group-append">
                                                    <div class="input-group-text">
                                                        <i title="Add" v-if="kss_action_desc != ''" @click="addFormerComponent('action', kss_action_desc)" class="fas fa-plus"></i>
                                                        <i title="Add" v-if="kss_action_desc == ''" class="fas fa-plus fa-disabled"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h3 class="component-head txt-primary bg-secondary">Hidden Committments<br/> to my Past-Self</h3>
                                             <div>
                                                <ul>
                                                    <li v-for="(committment, index) in past_committments" :key="index" >
                                                        {{committment}}&nbsp; <i  @click="deleteFormerComp(committment, 'committment')" class="fas fa-trash fai-red fai-sm" title="Delete"></i>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="input-group" style="font-size:.85em;">
                                                <input id="id_new_committment"  type="text" class="form-control" v-model="kss_committment_desc" placeholder="Committed to being the 'foodie'" required>
                                                <div  class="input-group-append">
                                                    <div class="input-group-text">
                                                        <i  title="Add"  v-if="kss_committment_desc != ''" @click="addFormerComponent('committment', kss_committment_desc)" class="fas fa-plus"></i>
                                                        <i  title="Add" v-if="kss_committment_desc == ''" class="fas fa-plus fa-disabled"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h3 class="component-head txt-primary bg-secondary">Limiting <br/>Beliefs/Assumptions</h3>
                                            <div>
                                                <ul>
                                                    <li v-for="(belief, index) in past_beliefs" :key="index" >
                                                        {{belief}}&nbsp; <i  @click="deleteFormerComp(belief, 'belief')" class="fas fa-trash fai-red fai-sm" title="Delete"></i>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="input-group" style="font-size:.85em;">
                                                <input id="id_new_belief"  type="text" class="form-control" v-model="kss_belief_desc" placeholder="I assume if I stop being the 'foodie' I won't connect with others" required>
                                                <div  class="input-group-append">
                                                    <div class="input-group-text">
                                                        <i title="Add" v-if="kss_belief_desc != ''" @click="addFormerComponent('belief', kss_belief_desc)" class="fas fa-plus"></i>
                                                        <i title="Add" v-if="kss_belief_desc == ''" class="fas fa-plus fa-disabled"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mx-auto my-2">
                                            <button class="btn btn-sm btn-warning mx-auto mt-2"  @click="saveAnalysis(TYPE_PAST)" :disabled="!(past_actions.length>0 && past_committments.length > 0 && past_beliefs.length > 0)||formerSituationSaved">Save Current Situation</button>
                                        </div>
                                    </div>
<div v-if="formerSituationSaved" class="periods-head" style="background-color:black;">&nbsp;</div>
 <div v-if="formerSituationSaved" class="periods-head">Me: aligned with my Future-Self</div>
                                    <div v-if="formerSituationSaved" class="row justify-content-between" >

                                        <div class="col-4">
                                             <h3  class="component-head txt-primary bg-secondary">Goal-Supporting<br/> Actions/Inactions </h3>
<small style="color:brown;">Stop doing the wrong things.  Start doing right things: Right things in the Right way, with the Biggest Upside.</small>
                                            <div>
                                                <ul>
                                                    <li v-for="(action, index) in new_actions" :key="index" >
                                                        {{action}}&nbsp; <i  @click="deleteNewComp(action, 'action')" class="fas fa-trash fai-red fai-sm" title="Delete"></i>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="input-group" style="font-size:.85em;">
                                                <input id="id_new_action"  type="text" class="form-control" v-model="new_kss_action_desc" placeholder="Stop snacking and Binging" required>
                                                <div  class="input-group-append">
                                                    <div class="input-group-text">
                                                        <i title="Add" v-if="new_kss_action_desc != ''" @click="addNewComponent('action', new_kss_action_desc)" class="fas fa-plus"></i>
                                                         <i title="Add" v-if="new_kss_action_desc == ''" class="fas fa-plus fa-disabled"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h3 class="component-head txt-primary bg-secondary">New Committments<br/> to my Future-Self</h3>
                                             <div>
                                                <ul>
                                                    <li v-for="(committment, index) in new_committments" :key="index" >
                                                        {{committment}}&nbsp; <i  @click="deleteNewComp(committment, 'committment')" class="fas fa-trash fai-red fai-sm" title="Delete"></i>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="input-group" style="font-size:.85em;">
                                                <input id="id_new_committment"  type="text" class="form-control" v-model="new_kss_committment_desc" placeholder="Committed to my future body" required>
                                                <div  class="input-group-append">
                                                    <div class="input-group-text">
                                                        <i title="Add" v-if="new_kss_committment_desc != ''" @click="addNewComponent('committment', new_kss_committment_desc)" class="fas fa-plus"></i>
                                                         <i title="Add" v-if="new_kss_committment_desc == ''" class="fas fa-plus fa-disabled"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h3 class="component-head txt-primary bg-secondary">Empowering <br/>Beliefs/Assumptions</h3>
                                            <div>
                                                <ul>
                                                    <li v-for="(belief, index) in new_beliefs" :key="index" >
                                                        {{belief}}&nbsp; <i  @click="deleteNewComp(belief, 'belief')" class="fas fa-trash fai-red fai-sm" title="Delete"></i>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="input-group" style="font-size:.85em;">
                                                <input id="id_new_belief"  type="text" class="form-control" v-model="new_kss_belief_desc" placeholder="I don't need food to connect with people" required>
                                                <div  class="input-group-append">
                                                    <div class="input-group-text">
                                                        <i title="Add" v-if="new_kss_belief_desc != ''" @click="addNewComponent('belief', new_kss_belief_desc)" class="fas fa-plus"></i>
                                                        <i title="Add" v-if="new_kss_belief_desc == ''" class="fas fa-plus fa-disabled"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mx-auto my-2">
                                            <button class="btn btn-sm btn-warning mx-auto mt-2"  @click="saveAnalysis(TYPE_NEW)" :disabled="!(new_actions.length>0 && new_committments.length > 0 && new_beliefs.length > 0)|| newSituationSaved">Save New Strategy</button>
                                            <button class="btn btn-sm btn-warning mx-auto mt-2"  @click="finalizeKSS()" :hidden="!formerSituationSaved || !newSituationSaved">Finalize this Strategy</button>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="allKSSs.length < MAX_ACTION_HABITS && !hideHeaderInputs" class="row d-flex ">
                                    <div  class="col-lg-6 col-md-6 col-sm-12">
                                        <div  class="content-box-gray card" > <!--:hidden="hideHeaderInputs"-->
                                            <div class="title text-center">
                                                <h5 class="mt-2" style="margin:auto;" >My Goal</h5>
                                            </div>
                                            <div class="content">
                                                <div class="input-group" style="font-size:.85em;">
                                                    <h6 :hidden="!hideHeaderInputs"  style="font-size:.85em;"><em>Desired Goal:</em> {{kss_name}}</h6>
                                                    <input id="id_habitname" :hidden="hideHeaderInputs" type="text" class="form-control" v-model="kss_name" placeholder="Desired State: e.g., Lose Weight" required>
                                                    <div  :hidden="hideHeaderInputs" class="input-group-append">
                                                        <div class="input-group-text">
                                                            <span class="fas fa-file-signature"></span>
                                                            <small class="small text-danger mb-3" v-html="errors.name"></small>
                                                            <small class="small text-primary mb-3" v-html="errors.header"></small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="input-group" style="font-size:.85em;">
                                                    <h6 :hidden="!hideHeaderInputs"  style="font-size:.85em;"><em>Description:</em> {{kss_desc}}</h6>
                                                    <input id="id_habitdesc" :hidden="hideHeaderInputs" type="text" class="form-control" v-model="kss_desc" placeholder="To achieve better health & feel more confident" required>
                                                    <div  :hidden="hideHeaderInputs" class="input-group-append">
                                                        <div class="input-group-text">
                                                        <span class="fas fa-info"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <small v-if="!current_ksscomponents || current_ksscomponents.length < 1" class="small text-danger mb-1" v-html="errors.header"></small> -->
                                                <div class=" btn-container">
                                                    <button class="btn btn-warning btn-sm" :disabled="(kss_name.length < 4 || kss_desc.length < 3)" :hidden="hideHeaderInputs" id="confHeadBtn" @click="confirmHeaders()"
                                                        title="confirm">Step 1: Save<span class="fas fa-save"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div  v-if="allKSSs.length>=MAX_ACTION_HABITS" class="row" style="text-align:center;">
                                    <div class="col-12 mx-auto"><p style="color:brown;">We suggest focusing on {{ MAX_ACTION_HABITS }} Self-Sabotage behaviors as optimal.<br/>Focus on these {{ MAX_ACTION_HABITS }} and delete/replace them when you've fixed those Self-Sabotaging behaviours.</p>
                                </div>
                            </div>
                    </div>

                    <div class="row " v-if="allKSSs.length>0">
                        <div  class="col-auto col-lg-6 col-md-6 col-sm-12" style="margin:auto;">
                            <div class="content-box-gray card" >
                                    <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >My Self-Sabotage Focus:</h5>
                                    </div>
                                    <div class="content">
                                        <table style="font-size: .75em;" class="table table-striped">
                                            <thead class="thead-dark">  <tr ><th>Desired Goal<br/><small>(What it will do for you)</small></th><th>Actions</th></tr></thead>
                                            <tr v-for="kss in allKSSs" :key="kss.id">
                                                <td><span><em>{{kss.name}}</em><br/><small>{{kss.description}}</small></span></td><td>
                                                    <i  @click="edit(kss.id)" class="fas fa-pen fai-black" title="Edit"></i>
                                                    <i  @click="trackKSS(kss.id)" class="fas fa-shoe-prints fai-green" title="Focus on Strategy"></i><br/>
                                                    <i  @click="habitPerformance(kss.id)" class="fas fa-eye fai-black" title="View My Focus-Efforts"></i>
                                                    <i  @click="swalConfirmDelete(kss.id)" class="fas fa-trash fai-red" title="Delete"></i>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        <!--    </div>
            </div>
        </div> -->

            </div>
        </div>
    </div>
</template>
<script>

import axios from 'axios';
import EventBus from '../../event-bus';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import { v4 as uuidv4 } from 'uuid';
import HABITSETUPHEADERINFO from '../global/shared/info'


export default {
    components: { Errors },
    name: "KillSelfSabotageSetup",
    data() {
        return {
            MAX_ACTION_HABITS: 4,
            MAX_HABIT_COMPONENTS:4,
            TYPE_PAST: 'FORMER',
            TYPE_NEW: 'NEW',
            COMPONENT_TYPE_ACTION: 'action',
            COMPONENT_TYPE_BELIEF: 'belief',
            COMPONENT_TYPE_COMMITTMENT: 'committment',
            name: '',
            email: '',
            username: '',
            success: false,
            failure: false,
            msg_msg: '',
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                name:'',
                hc_add: '',
                hc_confirm: '',
                maxed_components:''
            },
             userdata: '',
            nahme:'',
            // currentComponent: {
            //    description:'',
            //     type:'',
            // },
            current_KSSdata:[],
            current_KSScommittments:[],
            current_KSSbeliefs:[],
            current_KSSactions:[],
            kss_name: '',
            kssName:'',
            kss_desc:'',
            kssDesc:'',
            hideHeaderInputs:false,
            // kssCommittmentsTally:{type: '', count: 0},
            // kssActionsTally:{type: '', count: 0},
            // kssBeliefsTally:{type: '', count: 0},
            // kssComponentsTally:[],

            // customelementstracker:[],
            // selectedDeleteElement:'',
            buttonAwakeN:false,
            buttonAwakeF:false,
            kssc_name:'',
            kssc_desc:'',
            saved_kill_selfsabotage_id: '',
            allKSSs:[],
            alltrackingdata:[],
            headerHTML: '',
            videoData:'',
            kss_action_desc:'',
            kss_committment_desc:'',
            kss_belief_desc:'',
            kill_selfsabotage_id:'', //the current id
            past_actions:[],
            past_committments: [],
            past_beliefs: [],
            new_actions:[],
            new_committments: [],
            new_beliefs: [],
            formerSituationSaved:false,
            newSituationSaved:false,
            editStatus:false,
            new_kss_belief_desc:'',
            new_kss_committment_desc:'',
            new_kss_action_desc:'',


        }
    },
    props: {
        user:'',
        kss:[],
        tracking:[],
        videolinks:[],

    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.allKSSs = JSON.parse(this.kss);
        this.alltrackingdata = JSON.parse(this.tracking);
        this.videoData = JSON.parse(this.videolinks);
        this.componentName = new Array(this.MAX_HABIT_COMPONENTS);
        this.deleteComponent = new Array(this.MAX_HABIT_COMPONENTS);
        this.headerHTML = HABITSETUPHEADERINFO;
console.log("KSSSetup mounted");
    },

    methods: {
        edit(kill_selfsabotage_id) {
              console.error('edit called.....' + kill_selfsabotage_id);
            var selKSSData = this.getKSSData(kill_selfsabotage_id);
            console.error("Habit: " + selKSSData.name);
this.kill_selfsabotage_id = selKSSData.id;
this.kss_name = selKSSData.name;
this.kss_desc = selKSSData.description;
 this.current_KSSdata = selKSSData;
 this.current_KSScommittments= selKSSData.committments;
 this.current_KSSbeliefs = selKSSData.beliefs;
 this.current_KSSactions =selKSSData.actions;
//   past_actions:[],
//             past_committments: [],
//             past_beliefs: [],
//             new_actions:[],
//             new_committments: [],
//             new_beliefs: [],
this.splitDataIntoFormerNew();
        },
   getArrayFromDescription(componentArr, FORMER_or_NEW){
            var arr = [];
            var descArr = [];
            componentArr.forEach((obj) => {
                if(obj.type == FORMER_or_NEW) {
                    descArr = JSON.parse(obj.description);
                    // console.log(obj.type);
                    for (var i = 0; i < descArr.length; i++) {
                        var entry = descArr[i];
                        // console.log(entry);
                        arr.push(entry);
                    }
                }
            });
        return arr;
        },
        splitDataIntoFormerNew(){
            this.past_actions = this.getArrayFromDescription(this.current_KSSactions, 'FORMER');
            this.new_actions = this.getArrayFromDescription(this.current_KSSactions, 'NEW');
            this.past_committments = this.getArrayFromDescription(this.current_KSScommittments, 'FORMER');
            this.new_committments = this.getArrayFromDescription(this.current_KSScommittments, 'NEW');
            this.past_beliefs = this.getArrayFromDescription(this.current_KSSbeliefs, 'FORMER');
            this.new_beliefs = this.getArrayFromDescription(this.current_KSSbeliefs, 'NEW');
        },


        finalizeKSS() {
            this.updateToastNoConfirm('Your Self-Sabotage Elimination Analysis has been saved', 4000, 'success', false);
            location.reload();
        },
        saveAnalysis(FORMER_or_NEW) {
            var jsonActions, jsonCommittments, jsonBeliefs;
             if(FORMER_or_NEW == 'FORMER') {
                jsonActions =  JSON.stringify(this.past_actions);
                jsonCommittments=  JSON.stringify(this.past_committments);
                jsonBeliefs =  JSON.stringify(this.past_beliefs);
            } else {
                jsonActions =  JSON.stringify(this.new_actions);
                jsonCommittments=  JSON.stringify(this.new_committments);
                jsonBeliefs =  JSON.stringify(this.new_beliefs);
            }
            axios.post('/eliminatess/components/saveupdate', {
                user_id:this.userdata.id,
                former_or_new: FORMER_or_NEW,
                data_actions: JSON.stringify(jsonActions),
                data_committments: JSON.stringify(jsonCommittments),
                data_beliefs:  JSON.stringify(jsonBeliefs),
                kill_selfsabotage_id:  this.kill_selfsabotage_id,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                this.current_KSSdata = JSON.parse(res.data.current_kill_selfsabotage);
                this.current_KSScommittments = JSON.parse(res.data.committments);
                this.current_KSSactions = JSON.parse(res.data.actions);
                this.current_KSSbeliefs = JSON.parse(res.data.beliefs);
                this.updateToast(this.msg_msg, 4000, 'success');
                this.errors.header = "Analysis saved!";
                console.error("FORMER_or_NEW" + FORMER_or_NEW);
                if(FORMER_or_NEW == this.TYPE_PAST) this.formerSituationSaved=true;
                if(FORMER_or_NEW == this.TYPE_NEW) {
                    console.error("setting newSituationSaved to true");
                    this.newSituationSaved = true;
                }
                this.failure = false;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(()=> {
                // location.reload();
            });
        },

        // formatComponent(kss_component_desc) {
        //     var retVal = '';
        //        retVal =  kss_component_desc + ` <i  @click="deleteComp(${kss_component_desc})" class="fas fa-trash fai-red" title="Delete"></i>`;
        //     return retVal;
        // },

        deleteFormerComp(kss_component_desc, component_type) {
             console.error("addComponent: " + component_type + " " + kss_component_desc);
            if(component_type == 'action') {
                this.past_actions =  this.past_actions.filter(item => item !== kss_component_desc);
            }
            if(component_type == 'committment') {
                this.past_committments =  this.past_committments.filter(item => item !== kss_component_desc);
            }
            if(component_type == 'belief') {
                this.past_beliefs =  this.past_beliefs.filter(item => item !== kss_component_desc);
            }
            this.formerSituationSaved = false;
        },

        addFormerComponent(component_type, kss_component_desc) {
            console.error("addComponent: " + component_type + " " + kss_component_desc);
            if(component_type == 'action') {
                this.past_actions.push(kss_component_desc);
                this.kss_action_desc = '';
            }
            if(component_type == 'committment') {
                this.past_committments.push(kss_component_desc);
                this.kss_committment_desc = '';
            }
            if(component_type == 'belief') {
                this.past_beliefs.push(kss_component_desc);
                this.kss_belief_desc = '';
            }
            this.formerSituationSaved = false;
        },
        deleteNewComp(kss_component_desc, component_type) {
             console.error("addComponent: " + component_type + " " + kss_component_desc);
            if(component_type == 'action') {
                this.new_actions =  this.new_actions.filter(item => item !== kss_component_desc);
            }
            if(component_type == 'committment') {
                this.new_committments =  this.new_committments.filter(item => item !== kss_component_desc);
            }
            if(component_type == 'belief') {
                this.new_beliefs =  this.new_beliefs.filter(item => item !== kss_component_desc);
            }
            this.newSituationSaved = false;
        },

        addNewComponent(component_type, kss_component_desc) {
            console.error("addComponent: " + component_type + " " + kss_component_desc);
            if(component_type == 'action') {
                this.new_actions.push(kss_component_desc);
                this.new_kss_action_desc = '';
            }
            if(component_type == 'committment') {
                this.new_committments.push(kss_component_desc);
                this.new_kss_committment_desc = '';
            }
            if(component_type == 'belief') {
                this.new_beliefs.push(kss_component_desc);
                this.new_kss_belief_desc = '';
            }
            this.newSituationSaved = false;
        },

        updateKSSWatchlist(){
            console.error('upd called');
            if ( this.kssName != '' &&  this.kssDesc != ''
                    && this.current_KSScommittments.length > 0
                    && this.current_KSSactions.length > 0
                    && this.current_KSSbeliefs.length > 0) {
                        this.updateToast("Congrats. Your Habit is fully created", 2000, 'success');
                        window.location.reload();
            } else {
                // console.error('upd called throwing error');
                this.errors.hc_confirm = 'Please create a Self-Sabotage (Header) and at least one Action/Inaction, Hidden Committment and Limiting Belief/Assumption';
            }
        },

        checkCreatedHabit() {
            return !( this.kssName != '' &&  this.kssDesc != ''
                && (this.current_ksscomponents
                && this.current_ksscomponents.length > 0));
        },

        viewHabitResults(habitID) {
            //  console.error('viewHabitChart.....');
            window.location.replace('/eliminatess/'+ habitID + '/results/');
        },

        getGUID() {
            var guid = uuidv4();
            // console.log("GUID: " + guid);
            return guid;
        },

        getInputVal(el_id) {
            let inp = document.getElementById(el_id);
            // console.error(inp.value);
            return inp.value;
        },

        confirmHeaders(){
                console.log("Confirming Headers....");
                this.kssName = this.kss_name;
                this.kssDesc = this.kss_desc;
                this.hideHeaderInputs = true;
                this.saveHeaders(this.kssName, this.kssDesc);
        },

        trackKSS(kill_selfsabotage_id) {
            console.error('track habit called.....');
            var selKSSData = this.getKSSData(kill_selfsabotage_id);
            var data = {kssdata: selKSSData, userdata:this.userdata }
            EventBus.$emit('displayKSSTrackerModal', data);
        },

        habitPerformance(kill_selfsabotage_id) {
            console.error('habitPerformance called.....' + kill_selfsabotage_id);
            var selKSSData = this.getKSSData(kill_selfsabotage_id);
            console.error("Habit: " + selKSSData.name);
            var selKSSTrackingData = this.getKSSTrackingData(kill_selfsabotage_id);
            console.error("Tracking data: " + selKSSTrackingData.length);
            var data = {kssdata: selKSSData, userdata:this.userdata, ksstrakkerdata: selKSSTrackingData};
            EventBus.$emit('displayKSSResultsModal', data);
        },


        getKSSData(habit_id) {
            // console.log("Looking for Habit with id: " + habit_id);
            var retVal = '';
            this.allKSSs.forEach((aKSS)=>{
                // console.log(aHabit.name + aHabit.id);
                if(aKSS.id == habit_id)  {
                    console.log("Found KSS : " + aKSS.name);
                    retVal =  aKSS;
                }
            });
            return retVal;
        },

        getKSSTrackingData(kill_selfsabotage_id) {
            var retVal = [];
             [...this.alltrackingdata].forEach((aTrackingData)=>{
                if(aTrackingData.kill_selfsabotage_id == kill_selfsabotage_id) {
                    console.log("Found: " + aTrackingData.attempt_count + ' ' + aTrackingData.streak + ' ' + aTrackingData.id);
                    retVal.push(aTrackingData);
                }
            });
            return retVal;
        },

        saveHeaders(kss_name, kss_description) {
            axios.post('/eliminatess/saveupdate', {
                user_id:this.userdata.id,
                kill_selfsabotage_id: this.kill_selfsabotage_id,
                name: kss_name,
                description: kss_description
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                this.kill_selfsabotage_id = res.data.kill_selfsabotage_id;
                // console.error(res.data.message + ' ' + this.saved_habit_id);
                this.errors.header = "Goal-Header saved.  Now define your challenge!"
                this.failure = false;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(()=> {
                // location.reload();
            });
        },

        deleteComponent(component_id) {
            axios.post('/eliminatess/components/delete', {
                component_id: component_id,
                user_id: this.userdata.id
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                // console.error(res.data.message );
                this.habitdata = JSON.parse(res.data.current_habit);
                this.habitcomponents = this.habitdata.components;
                this.failure = false;
                this.hc_name = '';
                this.hc_desc = '';
                this.hc_weight = '';
                this.errors.hc_add ="";
                this.habitcomponentstally--;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            });
        },

        saveComponent(component_id, name, desc) {
            axios.post('/eliminatess/component/saveupdate', {
                id: component_id,
                action_habit_id: this.saved_habit_id,
                name: name,
                description: desc
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                console.error(res.data.message );
                this.current_actionhabitdata = JSON.parse(res.data.current_action_habit);
                this.current_actionhabitcomponents = this.current_actionhabitdata.components;
                console.error(this.current_actionhabitdata );
                console.error(this.current_actionhabitcomponents );
                this.failure = false;
                this.hc_name = '';
                this.hc_desc = '';
                this.habitcomponentstally++;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(()=> {
                if(this.success) {
                    console.log("Saved component... doing finally");
                    this.errors.hc_add ="Action-Habit component saved.";
                    if(this.habitcomponentstally>= this.MAX_HABIT_COMPONENTS) {
                        this.errors.hc_add += " Max components created." + this.MAX_HABIT_COMPONENTS;
                    } else {
                        this.errors.hc_add += " Create another one?"
                    }
                    console.log("should display message: " + this.errors.hc_add);
                }
            });
        },

        deleteKSS(kill_selfsabotage_id) {
            let incomingdata = '';
            console.error("Deleting habit: " + kill_selfsabotage_id);
            axios.post('/eliminatess/delete', {
                user_id:this.userdata.id,
                kill_selfsabotage_id: kill_selfsabotage_id
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                this.errors.success = true;
                console.error( kill_selfsabotage_id  + " " +this.msg_msg);
                this.removeKSSfromKSSData(kill_selfsabotage_id);
                this.failure = false;
                this.updateToast(this.msg_msg, 2000, icon='success');
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(() => {
                this.$forceUpdate();
            });
        },

        removeKSSfromKSSData(kill_selfsabotage_id) {
             this.allKSSs = this.allKSSs.filter(function (kss){
            return kss.id !== kill_selfsabotage_id});
        },

        maxxedOutKSSComponent(component_type) {
            // console.log(this.habitcomponentstally >= this.MAX_HABIT_COMPONENTS);
            this.errors.maxed_components = 'We recommend not trying to fix too many Components.';
            this.getTallyForType(type);
            return this.habitcomponentstally >= this.MAX_HABIT_COMPONENTS;
        },

        addCustomHabitCheck() {
            if(this.hc_name.length >0 && this.hc_desc.length >0) {
                this.saveComponent('', this.hc_name,this.hc_desc);
                this.errors.hc_add =  (this.habitcomponentstally>=4)? "We recommend not trying to track too many habit components.<br/> (Generally 4 components on each habit is a good number).":'';
            } else {
                // console.error("Nothing added to Habit Components...")
                var err = '';
                if(this.hc_name.length<5) err= 'Component Name should be longer than 4 letters';
                this.errors.hc_add = err;
            }
        },

        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        updateToastNoConfirm(message, timer = 2000, icon='success', showConfirmButton = false) {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: showConfirmButton,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

        swalConfirmDelete(id) {
             Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to undo this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    // setTimeout( function (id) {
                    //     this.doDeleteSlice(id);
                    // }, 3000);
                    this.deleteKSS(id);
                    // Swal.fire(
                    //     'Deletion in progress!',
                    //     '',
                    //     'success'
                    // );
                }
            });
        },
    }
}
</script>

<style scoped>
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:#0707c0;
}
.fai-black{
    color:#000;
}
.fai-sm {
    font-size:x-small;
}
.fa-disabled {
     color:#b1b1b3;
}
.content-box-darkblue .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#0c3acf;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
.input-group input, select{
    margin-top:.2em;
}
.input-group .input-group-text{
    margin-top:.2em;
}
.shad{
padding:.2em;
padding-top:1em;
margin:.2em;
margin-bottom: 1em;
background: #f1f2f4;
border: 2.5px solid #fff;
border-radius: 4px;
box-shadow: 4px 4px 4px #222;
}
.how-to{
width:80%;
    @media (max-width: 768px) {
        width:90%;
    }
}

.goal-head{
background: #212c3e;
color: #d6a30a;
font-size:larger;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}
.component-head{
background: #687b9a;
color: #2003fc;
font-size:large;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}
.periods-head{
background: #d6a30a;
color: #0f0f0f;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}

</style>
